import React, { Component } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Form } from "react-bootstrap";

class TextEditor extends Component {
  constructor(props) {
    super(props);

    let plugins = [];
    let toolbar = "";
    let height = 300;
    let content = "";

    // ✅ SAME OLD CONDITION (UNCHANGED LOGIC)
    if (this.props.type == "studentnote") {
      height = 360;

      plugins = [
        "image",
        "searchreplace wordcount visualblocks code fullscreen",
        "insertdatetime media table paste code",
      ];

      content = this.props.content;

      toolbar =
        "insertfile undo redo | styleselect | bold italic | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | image | fullscreen";
    } else {
      plugins = [
        "advlist autolink lists link image charmap print preview anchor",
        "insertdatetime media table paste code",
      ];

      toolbar =
        "insertfile undo redo | styleselect | bold italic | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | link image";

      content = this.props.value || this.props.content || "";
    }

    this.state = {
      plugins,
      toolbar,
      content,
      height,
    };
  }

  render() {
    // ✅ KEEP YOUR EXISTING SAFETY CHECK
    if (typeof window !== "undefined" && !window.tinymce) {
      return (
        <div className="alert alert-warning">
          TinyMCE editor is loading or could not be loaded.
        </div>
      );
    }

    return (
      <>
        {/* ✅ KEEP (for compatibility, even if not used) */}
        <Form.Group controlId="my-file" style={{ display: "none" }}>
          <Form.Control type="file" name="my-file" />
        </Form.Group>

        <Editor
          value={this.state.content}
          
          onEditorChange={(content) => {
            this.setState({ content });
            if (this.props.handleEditorChange) {
              this.props.handleEditorChange(content);
            }
          }}

          onInit={(evt, editor) => {
            if (this.props.onInit) {
              this.props.onInit(editor);
            }
          }}

          init={{
            height: this.state.height,
            menubar: false,

            plugins: this.state.plugins,
            toolbar: this.state.toolbar,

            content_style:
              "body { font-size:14px; font-family: Arial; }",

            // ✅ REPLACEMENT for old file_picker_callback
            images_upload_handler: (blobInfo) => {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blobInfo.blob());
              });
            },

            paste_data_images: true,
          }}
        />
      </>
    );
  }
}

export default TextEditor;